import { NgModule, CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA } from '@angular/core';
import { SendConfirmationMasterComponent } from './send-confirmation-master/send-confirmation-master.component';
import { SendConfirmationHomeRoutingModule } from './send-confirmation-home-routing.module';


import { LinkModule } from "@vg-constellation/angular-19/link";
import { HttpClientModule } from "@angular/common/http";
import { IconModule } from "@vg-constellation/angular-19/icon";
import { NavOverflowModule } from "@vg-constellation/angular-19/nav-overflow";
import { SpinnerModule } from "@vg-constellation/angular-19/spinner";
import { CardComponent } from "@vg-constellation/angular-19/card";
import { ButtonModule } from "@vg-constellation/angular-19/button";
import { StepIndicatorModule } from "@vg-constellation/angular-19/step-indicator";
import { LabelModule } from "@vg-constellation/angular-19/label";
import { HintErrorModule } from "@vg-constellation/angular-19/hint-error";
import { InputModule } from "@vg-constellation/angular-19/input";
import { SelectModule } from "@vg-constellation/angular-19/select";
import { CheckboxModule } from '@vg-constellation/angular-19/checkbox';
import { RadioModule } from '@vg-constellation/angular-19/radio';
import { ModalDialogModule } from '@vg-constellation/angular-19/modal-dialog';
import {BannerComponent} from "@vg-constellation/angular-19/banner";
import {InternalCalloutComponent} from "@vg-constellation/angular-19/internal-callout";
import {DetailsComponent} from "@vg-constellation/angular-19/details";
import { SendConfirmationComponent } from './send-duplicate-confirmation/send-confirmation.component';
import { ReviewSubmitComponent } from './review-and-submit/review-submit.component';
import { confirmationReducer } from '../../state/reducers/reducer';


@NgModule({
  declarations: [],
  imports: [ SendConfirmationHomeRoutingModule, SendConfirmationMasterComponent, SendConfirmationComponent, ReviewSubmitComponent ],
  exports: [
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA,NO_ERRORS_SCHEMA]
})
export class SendconfirmationHomeModule { }
